export const IMPORT_RELEASE_SET_LOADING = "IMPORT_RELEASE_SET_LOADING";
export const IMPORT_RELEASE_STOP_LOADING = "IMPORT_RELEASE_STOP_LOADING";
export const FETCH_IMPORT_DATA = "FETCH_IMPORT_DATA";
export const FETCH_IMPORT_DATA_SUCCESS = "FETCH_IMPORT_DATA_SUCCESS";
export const FETCH_IMPORT_DATA_FALSE = "FETCH_IMPORT_DATA_FALSE";
export const CLEAR_IMPORT_DATA_ERROR_MESSAGE =
  "CLEAR_IMPORT_DATA_ERROR_MESSAGE";
